import React, { useState, useEffect } from 'react';
import { AdminAccess } from '../components/ui/admin-access';
import { AdminDashboard } from '../components/ui/admin-dashboard';
import { Button } from '../components/ui/button';
import { LogOut, Home } from 'lucide-react';
import { Link } from 'react-router-dom';

export const AdminPage = () => {
  const [hasAccess, setHasAccess] = useState(false);

  // Check if user already has access
  useEffect(() => {
    const access = localStorage.getItem('adminAccess');
    if (access === 'true') {
      setHasAccess(true);
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('adminAccess');
    setHasAccess(false);
  };

  if (!hasAccess) {
    return <AdminAccess onAccess={setHasAccess} />;
  }

  return (
    <div>
      {/* Admin Header */}
      <div className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <img 
              src="https://customer-assets.emergentagent.com/job_agi-layer/artifacts/qru87chk_Need%20a%20hair%20makeover%20letterhead%20banner_20250404_081637_0001.png"
              alt="Need A Hair Makeover"
              className="h-10"
            />
            <div>
              <h1 className="text-lg font-semibold text-dark">Admin Dashboard</h1>
              <p className="text-sm text-subtle">Franchise Lead Management</p>
            </div>
          </div>
          
          <div className="flex items-center space-x-3">
            <Link to="/">
              <Button variant="outline" size="sm">
                <Home className="h-4 w-4 mr-2" />
                Back to Site
              </Button>
            </Link>
            
            <Button variant="outline" size="sm" onClick={handleLogout}>
              <LogOut className="h-4 w-4 mr-2" />
              Logout
            </Button>
          </div>
        </div>
      </div>

      {/* Dashboard Content */}
      <AdminDashboard />
    </div>
  );
};